/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Star } from "@phosphor-icons/react";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as Api } from "../../../assets/svg/api.svg";
import { ReactComponent as Arrow } from "../../../assets/svg/arrow-up-right.svg";
import { ReactComponent as Doc } from "../../../assets/svg/book-open.svg";
import { ReactComponent as Info } from "../../../assets/svg/info.svg";
import { ReactComponent as MediaKit } from "../../../assets/svg/mediakit.svg";
import { LAYER_COLORS } from "../../../constants/design/colors";
import { SPACING } from "../../../constants/design/spacing";
import { LINKS } from "../../../constants/links";
import { PageEndpointEnum } from "../../../enums/endpoint";
import { Chevron } from "../Chevron/style";
import Dropdown from "../Dropdown";
import {
  CommunityRow,
  CommunityRowLabel,
  DropdownWrapper,
  HeaderItemsWrapper,
  LinkText,
} from "./style";

interface IHeaderNavProps {
  setShowAboutMarginXModal: (show: boolean) => void;
}

export function HeaderNav({ setShowAboutMarginXModal }: IHeaderNavProps) {
  const location = useLocation();
  const activePageEndpointEnum = useMemo(() => {
    const activePage = location.pathname;
    if (activePage.includes(PageEndpointEnum.REFERRALS)) {
      return PageEndpointEnum.REFERRALS;
    }
    if (activePage.includes(PageEndpointEnum.PORTFOLIO)) {
      return PageEndpointEnum.PORTFOLIO;
    }
    if (activePage.includes(PageEndpointEnum.MARGINX)) {
      return PageEndpointEnum.MARGINX;
    }
    if (activePage.includes(PageEndpointEnum.LEADERBOARD)) {
      return PageEndpointEnum.LEADERBOARD;
    }
    if (activePage.includes(PageEndpointEnum.HISTORICAL)) {
      return PageEndpointEnum.HISTORICAL;
    }
    if (activePage.includes(PageEndpointEnum.RFQ)) {
      return PageEndpointEnum.RFQ;
    }
    // todo: readd
    // if (activePage.includes(PageEndpointEnum.STRATEGIES)) {
    //   return PageEndpointEnum.STRATEGIES;
    // }
    return PageEndpointEnum.TRADING;
  }, [location.pathname]);

  const [showCommunityDropdown, setShowCommunityDropdown] = useState(false);

  const { t } = useTranslation("app", { keyPrefix: "Header.Header" });
  const navigate = useNavigate();

  return (
    <HeaderItemsWrapper>
        <Link to={PageEndpointEnum.TRADING}>
          <LinkText
            isActive={activePageEndpointEnum === PageEndpointEnum.TRADING}
          >
            {t("trading")}
          </LinkText>
        </Link>
        <Link to={PageEndpointEnum.PORTFOLIO}>
          <LinkText
            isActive={activePageEndpointEnum === PageEndpointEnum.PORTFOLIO}
          >
            {t("portfolio")}
          </LinkText>
        </Link>
        <Link to={PageEndpointEnum.LEADERBOARD}>
          <LinkText
            isActive={activePageEndpointEnum === PageEndpointEnum.LEADERBOARD}
          >
            Leaderboard
          </LinkText>
        </Link>
        {/* todo: readd */}
        {/* <Link to={PageEndpointEnum.STRATEGIES}>
          <StrategiesWrapper>
            <LinkText
              isActive={activePageEndpointEnum === PageEndpointEnum.STRATEGIES}
            >
              {t("strategies")}
            </LinkText>
          </StrategiesWrapper>
        </Link> */}
        {/* <Link to={PageEndpointEnum.MARGINX}>
          <LinkText
            isActive={activePageEndpointEnum === PageEndpointEnum.MARGINX}
            isMarginXLogo
            showBlueMarginXLogo={
              !localStorage.getItem(LocalStorageKeyEnum.HIDE_BLUE_HEADER)
            }
            onClick={() =>
              localStorage.setItem(
                LocalStorageKeyEnum.HIDE_BLUE_HEADER,
                "true"
              )
            }
          >
            <Logo height={16} width={16} />
            MARGINX
          </LinkText>
        </Link> */}
        <Link to={`${PageEndpointEnum.PORTFOLIO}/referrals`}>
          <LinkText
            isActive={activePageEndpointEnum === PageEndpointEnum.REFERRALS}
          >
            {t("referrals")}
          </LinkText>
        </Link>
        <DropdownWrapper>
          <Dropdown
            onToggle={setShowCommunityDropdown}
            toggleStyles={{
              border: "none",
              backgroundColor: "transparent",
              padding: "0px !important",
            }}
            dropdownMenuContainerStyles={{
              overflow: "hidden",
              borderRadius: "8px",
              background: LAYER_COLORS.three,
            }}
            title={
              <LinkText isActive={showCommunityDropdown}>
                {t("more")}
                <Chevron
                  style={{
                    marginLeft: SPACING.one,
                    opacity: 1,
                  }}
                  direction={showCommunityDropdown ? "up" : "down"}
                />
              </LinkText>
            }
            items={[
              {
                label: (
                  <CommunityRow svgIsFill>
                    <Star weight="fill" />
                    <CommunityRowLabel>{t("watchlist")}</CommunityRowLabel>
                  </CommunityRow>
                ),
                onSelect: () => navigate(PageEndpointEnum.WATCHLIST),
              },
              // {
              //   label: (
              //     <CommunityRow>
              //       <RFQsLogo />
              //       <CommunityRowLabel>{t("rfq")}</CommunityRowLabel>
              //     </CommunityRow>
              //   ),
              //   onSelect: () => navigate(PageEndpointEnum.RFQ),
              // },
              // Historical Data is intentionally hidden for now.
              // To restore it, re-enable `useNavigate`, the Clock icon import,
              // `const navigate = useNavigate()`, and this menu item.
              // {
              //   label: (
              //     <CommunityRow>
              //       <Clock />
              //       <CommunityRowLabel>
              //         {t("historical_data")}
              //       </CommunityRowLabel>
              //     </CommunityRow>
              //   ),
              //   onSelect: () => navigate(PageEndpointEnum.HISTORICAL),
              // },
              {
                label: (
                  <CommunityRow>
                    <Info />
                    <CommunityRowLabel>{t("about")}</CommunityRowLabel>
                  </CommunityRow>
                ),
                onSelect: () => setShowAboutMarginXModal(true),
              },
              // Home is intentionally hidden from More.
              // To restore it, re-enable the Home icon import and this item.
              // {
              //   label: (
              //     <CommunityRow href={LINKS.home}>
              //       <Home />
              //       <CommunityRowLabel>
              //         {t("home")}
              //         <Arrow />
              //       </CommunityRowLabel>
              //     </CommunityRow>
              //   ),
              // },
              {
                label: (
                  <CommunityRow href={LINKS.docs}>
                    <Doc />
                    <CommunityRowLabel>
                      {t("docs")}
                      <Arrow />
                    </CommunityRowLabel>
                  </CommunityRow>
                ),
              },
              {
                label: (
                  <CommunityRow href={LINKS.apidocs}>
                    <Api />
                    <CommunityRowLabel>
                      {t("api_reference")}
                      <Arrow />
                    </CommunityRowLabel>
                  </CommunityRow>
                ),
              },
              // {
              //   label: (
              //     <CommunityRow svgIsFill href={LINKS.blog}>
              //       <Blog />
              //       <CommunityRowLabel>
              //         {t("blog")}
              //         <Arrow />
              //       </CommunityRowLabel>
              //     </CommunityRow>
              //   ),
              // },
              // {
              //   label: (
              //     <CommunityRow href={LINKS.dashboard}>
              //       <Dashboard />
              //       <CommunityRowLabel>
              //         {t("dashboard")}
              //         <Arrow />
              //       </CommunityRowLabel>
              //     </CommunityRow>
              //   ),
              // },
              {
                label: (
                  <CommunityRow noBorder href={LINKS.mediakit}>
                    <MediaKit />
                    <CommunityRowLabel>{t("media_kit")}</CommunityRowLabel>
                  </CommunityRow>
                ),
              },
            ]}
          />
        </DropdownWrapper>
        {/* <ExternalLinkText
          color={TEXT_COLORS.three}
          hoverColor={TEXT_COLORS.one}
          href={LINKS.otc}
          target="_blank"
          rel="noreferrer"
        >
          {t("otc")}
        </ExternalLinkText> */}
      </HeaderItemsWrapper>
  );
}
